// Product Tabs JavaScript
class ProductTabs {
  constructor() {
    this.tabButtons = document.querySelectorAll('.tab-button');
    this.tabContents = document.querySelectorAll('.tab-content');
    this.init();
  }

  init() {
    if (this.tabButtons.length === 0) return;
    
    this.bindEvents();
    this.addEntranceAnimations();
  }

  bindEvents() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleTabClick(e));
    });
  }

  handleTabClick(e) {
    const button = e.currentTarget;
    const targetTab = button.getAttribute('data-tab');
    
    // Add loading state
    const currentActive = document.querySelector('.tab-content.active');
    if (currentActive) {
      currentActive.style.opacity = '0.5';
    }
    
    setTimeout(() => {
      // Remove active class from all buttons and contents
      this.tabButtons.forEach(btn => btn.classList.remove('active'));
      this.tabContents.forEach(content => {
        content.classList.remove('active');
        content.style.opacity = '';
      });
      
      // Add active class to clicked button and corresponding content
      button.classList.add('active');
      const targetContent = document.getElementById(targetTab);
      if (targetContent) {
        targetContent.classList.add('active');
      }
      
      // Animate FAQ items if switching to questions tab
      if (targetTab === 'questions') {
        this.animateFAQItems();
      }
    }, 150);
  }

  animateFAQItems() {
    setTimeout(() => {
      const faqItems = document.querySelectorAll('.faq-item');
      faqItems.forEach((item, index) => {
        item.style.opacity = '0';
        item.style.transform = 'translateX(-30px)';
        setTimeout(() => {
          item.style.transition = 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
          item.style.opacity = '1';
          item.style.transform = 'translateX(0)';
        }, index * 100);
      });
    }, 200);
  }

  addEntranceAnimations() {
    // Animate tabs
    this.tabButtons.forEach((tab, index) => {
      tab.style.opacity = '0';
      tab.style.transform = 'translateY(-20px)';
      setTimeout(() => {
        tab.style.transition = 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        tab.style.opacity = '1';
        tab.style.transform = 'translateY(0)';
      }, index * 100);
    });
    
    // Animate content wrapper
    const wrapper = document.querySelector('.tab-content-wrapper');
    if (wrapper) {
      wrapper.style.opacity = '0';
      wrapper.style.transform = 'translateY(30px)';
      setTimeout(() => {
        wrapper.style.transition = 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
        wrapper.style.opacity = '1';
        wrapper.style.transform = 'translateY(0)';
      }, 300);
    }
  }
}

// FAQ Toggle Function
function toggleFAQ(questionElement) {
  const answer = questionElement.nextElementSibling;
  const faqItem = questionElement.parentElement;
  
  // Close all other FAQs
  document.querySelectorAll('.faq-question').forEach(q => {
    if (q !== questionElement) {
      q.classList.remove('active');
      q.nextElementSibling.classList.remove('active');
    }
  });
  
  // Toggle current FAQ
  questionElement.classList.toggle('active');
  answer.classList.toggle('active');
  
  // Add ripple effect
  const ripple = document.createElement('div');
  ripple.style.cssText = `
    position: absolute;
    border-radius: 50%;
    background: rgba(255,255,255,0.3);
    transform: scale(0);
    animation: ripple 0.6s linear;
    pointer-events: none;
    width: 100px;
    height: 100px;
    left: 50%;
    top: 50%;
    margin-left: -50px;
    margin-top: -50px;
  `;
  
  questionElement.appendChild(ripple);
  setTimeout(() => ripple.remove(), 600);
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  new ProductTabs();
});

// Add ripple animation styles
const style = document.createElement('style');
style.textContent = `
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);